import latinize from 'latinize';

export const includes = (str, text) =>
  latinize(String(str).toLowerCase()).includes(latinize(String(text).toLowerCase()));

export const insert = (str, index, text) => [str.slice(0, index), text, str.slice(index)].join('');
